import React, { useRef, useState } from 'react';
interface Props {
  onClick?: () => void;
}

const itemWidth = 38;
const itemHeight = 160;
const space = 10;
export default function FloatCustomer({ onClick }: Props) {
  const divRef = useRef<any>();

  const [left, setLeft] = useState<number>(window.innerWidth - itemWidth - space); // 向左移动的距离
  const [top, setTop] = useState<number>(window.innerHeight - itemHeight - 280); // 向上移动的距离
  function handleClick(e: any) {
    e.stopPropagation();
    e.preventDefault();
    if (onClick) {
      onClick!();
    }
  }

  //开始拖拽
  function handleDragStart() {
    divRef!.current!.style.transition = 'none';
    document.body.style.overflow = 'hidden';
  }
  //触摸移动
  function handleTouchMove(e: React.TouchEvent<HTMLDivElement>) {
    if (e.targetTouches.length === 1) {
      let touch = e.targetTouches[0];
      let left = touch.clientX - itemWidth / 2;
      let top = touch.clientY - itemHeight / 2;
      if (left < space) {
        left = space;
      }
      if (left > window.innerWidth - itemWidth - space) {
        left = window.innerWidth - itemWidth - space;
      }
      if (top < space) {
        top = space;
      }
      if (top > window.innerHeight - itemHeight - space) {
        top = window.innerHeight - itemHeight - space;
      }
      setLeft(left);
      setTop(top);
    }
  }
  function hanldeTouchEnd() {
    document.body.style.overflow = '';
  }

  return (
    <div
      className="bg-white d-shadow pos-f d-flex-c ai-center jc-center border-radius-8 z-300"
      ref={divRef}
      style={{
        width: `${itemWidth}px`,
        height: `${itemHeight}px`,
        left: `${left}px`,
        top: `${top}px`,
      }}
      onTouchStart={(e) => handleDragStart()}
      onTouchMove={(e) => handleTouchMove(e)}
      onTouchEnd={(e) => hanldeTouchEnd()}
    >
      <div className="mt-10 d-flex-c ai-center text-color-p" onClick={handleClick}>
        <img className="border-radius-harf icon-30" src="/pic/icon_kf.jpg" alt="" />
        <div className="d-flex-c font-widget-600 font-size-18 text-color-red mb-5">
          <span>在</span>
          <span>线</span>
          <span>客</span>
          <span>服</span>
        </div>
      </div>
    </div>
  );
}
